import * as publicFile from './public'
import * as adminFile from './admin'

export default Object.assign({},
    publicFile.default,
    adminFile.default
)